export const trailTimeFormat = 'HH:ss';
